import { render, staticRenderFns } from "./PublicDashboard.vue?vue&type=template&id=5fc05733&"
import script from "./PublicDashboard.vue?vue&type=script&lang=js&"
export * from "./PublicDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports